import { useForm } from '@inertiajs/react';

export default function RequestModelPage({ model, request }) {
    // requestStatus can be used for feedback, if provided by backend
    const isReadOnly = !!request;
    const { data, setData, post, processing, wasSuccessful, errors } = useForm({
        message: request?.message || '',
        estimated_usage: request?.estimated_usage || ''
    });

    const handleChange = (e) => {
        if (isReadOnly) return;
        setData(e.target.name, e.target.value);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (isReadOnly) return;
        post(`/models/${model.id}/request`);
    };

    return (
        <div className="flex flex-col items-center justify-center flex-grow mt-auto">
            <h1 className="text-1xl font-thin font-semibold text-gray-900 sm:text-2xl lg:text-3xl">
                Request {model.label}
            </h1>
            <div className="mt-8 w-full max-w-lg">
                {wasSuccessful && (
                    <div className="bg-green-100 border-l-4 border-green-400 text-green-700 p-4 rounded-md mb-6 shadow-sm">
                        <p>
                            Your model request has been submitted successfully!
                        </p>
                    </div>
                )}
                {errors.request && (
                    <div className="bg-red-100 border-l-4 border-red-400 text-red-700 p-4 rounded-md mb-6 shadow-sm">
                        <p>{errors.request}</p>
                    </div>
                )}
                {/* Optionally, show requestStatus feedback here */}
                <form onSubmit={handleSubmit} className="border border-gray-200 bg-white rounded-lg px-6 py-6 space-y-4">
                    
                     <p className="text-gray-700 mb-4">
                        We're excited to see your interest in the <strong>{model.label}</strong> model. 
                        Please provide us a biref description of your intended use and motivate how this model relevant for you or your work.
                    </p>

                    <hr/>
                    
                    <div>
                        <label className="block text-gray-800 text-base font-medium mb-2" htmlFor="message">
                            Descriptio of Intended Use
                        </label>
                        <textarea
                            id="message"
                            name="message"
                            value={data.message}
                            onChange={handleChange}
                            className="border border-gray-300 rounded-md w-full py-2 px-3 text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-400 transition"
                            placeholder="Describe how you plan to use this model..."
                            required
                            rows={3}
                            readOnly={isReadOnly}
                        />
                        {errors.message && <div className="text-red-500 text-sm mt-1">{errors.message}</div>}
                    </div>
                    <div>
                        <label className="block text-gray-800 text-base font-medium mb-2" htmlFor="estimated_usage">
                            Estimated Number of Images to Process
                        </label>
                        <input
                            id="estimated_usage"
                            name="estimated_usage"
                            type="number"
                            min="1"
                            value={data.estimated_usage}
                            onChange={handleChange}
                            className="border border-gray-300 rounded-md w-full py-2 px-3 text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-400 transition"
                            placeholder="e.g. 1000"
                            required
                            readOnly={isReadOnly}
                        />
                        {errors.estimated_usage && <div className="text-red-500 text-sm mt-1">{errors.estimated_usage}</div>}
                    </div>
                    {!isReadOnly && (
                        <button
                            type="submit"
                            className="w-full bg-slate-600 hover:bg-slate-700 text-white font-semibold py-2 rounded-md transition focus:outline-none focus:ring-2 focus:ring-blue-400"
                            disabled={processing}
                        >
                            {processing ? 'Submitting...' : 'Submit Model Request'}
                        </button>
                    )}
                </form>
                <div className="mt-6">
                    <p className="text-sm text-gray-500">
                        Note: Your request will be reviewed by our team. You may receive an email notification once the requested model becomes available. 
                        There is no guarantee that the model you requested will become available.
                    </p>
                </div>
            </div>
        </div>
    );
}